export const soldProducts = {
	tabTitle: "Total de productos vendidos",
	title: "Productos Vendidos",
	filter: "Filtrar por tipo de transacción",
	fileName: "total-productos-vendidos",
	printTitle: "Productos vendidos",
	table: {
		fiscalCode: "SKU",
		name: "Nombre",
		category: "Categoría",
		mountableProduct: "Armable",
		mountableProducts: "Armables",
		count: "Cantidad",
		unitValue: "Valor unitario",
		subtotal: "Subtotal",
		totalDiscount: "Descuentos",
		totalValue: "Valor total",
		product: "Producto",
		productCategory: "Categoría Producto",
		mountableStage: "Etapa Armable",
		mountableItem: "Item Armable",
		unitCount: "Cantidad Unit.",
		fracionalCount: "Cantidad Frac.",
		unitaryValue: "Valor unitario",
		mountableSection: "Sección Armable",
	},
	filterByProducts: "Filtrar por productos",
	filterByProductsPlaceholder: "Todos",
	filterByOperationType: "Filtrar por tipo de operación",
	filterByOperationTypePlaceholder: "Todas",
	filterByProductKind: "Filtrar por tipo de producto",
	productKindOptions: {
		food: "Alimentos",
		drinks: "Bebidas",
		tickets: "Boletería",
		other: "Otros",
	},
};
